<template>
  <p class="component-heading" v-if="showone == 'WithoutStockAffectPO' ||
    showone == 'POAmendment' ||
    showone == 'GRN With PO'
  ">
    {{ $t('PurchaseOrder.poname') }}
  </p>
  <b-row v-if="showone == 'WithoutStockAffectPO' ||
    showone == 'GRN With PO' ||
    showone == 'POAmendment' ||
    showone == 'WithoutStockAffectPI'
  ">
    <b-col lg="3" md="4" sm="6" v-if="showone == 'POAmendment' || showone == 'WithoutStockAffectPI'">
      <div class="field">
        <label>{{ $t('PurchaseIndent.piid') }}</label>
        <TextField name="" />
      </div>
    </b-col>

    <b-col lg="3" md="4" sm="6" v-if="showone == 'POAmendment' || showone == 'WithoutStockAffectPI'">
      <div class="field">
        <label>{{ $t('Request.requestid') }}</label>
        <Dropdown />
      </div>
    </b-col>

    <b-col lg="3" md="4" sm="6" v-if="showone == 'WithoutStockAffectPO' ||
      showone == 'POAmendment' ||
      showone == 'GRN With PO'
    ">
      <div class="field">
        <label>{{ $t('PurchaseOrder.ponameno') }}</label>

        <AutoCompleteCustom v-model="PurchaseformData.purchase" :items="dataOptions.purchaseOption"
          @input="ListPurchaseOrder" @item-select="poOnChange" :disabled="PurchaseformData.disabled" />
      </div>
    </b-col>

    <b-col lg="3" md="4" sm="6" v-if="showone == 'POAmendment'">
      <div class="field">
        <label>{{ $t('PurchaseOrder.date') }}</label>
        <Datepicker />
      </div>
    </b-col>
  </b-row>
</template>

<script lang="ts">
import { defineComponent, ref, reactive, watch, onMounted } from "vue";
import TextField from "../../../../components/FormComponents/TextInput.vue";
import Datepicker from "../../../../components/FormComponents/DatePicker.vue";
import CustomDropdown from "../../../../components/FormComponents/Dropdown.vue";
import commonservice from "../../Service/WithoutStockAffectService";
import AutoCompleteCustom from "../../../../components/FormComponents/AutoComplete.vue";

export default defineComponent({
  props: {
    showone: {
      type: String,
      default: "",
    },
    commonItemProps: {
      type: Object,
    },
    modelValue: {
      type: Object,
    },
    POId: {
      type: Number,
    },
    SupplierId: {
      type: Number,
      default: 0
    },
  },

  components: {
    TextField,
    Datepicker,
    CustomDropdown,
    AutoCompleteCustom,
  },
  setup(props, { emit }) {
    /*Variable Declaration*/
    const dataOptions = ref({
      purchaseOption: [],
      // purchaseName: ''
    });

    const PurchaseformData = reactive({
      purchaseId: 0,
      purchaseName: "",
      purchase: "",
      disabled: false,
    });

    let session: any = localStorage.getItem("UsersData");
    session = JSON.parse(session);
    let HospitalId = Number(session.OrganizationId);
    let BranchId = Number(session.BranchId);

    watch(props, (newValue) => {
      debugger;
      Object.assign(PurchaseformData, newValue.modelValue);

      if (newValue.POId) {
        POItemLoad(newValue.POId);
      }
      //LoadItem();
    });

    watch(
      () => props.SupplierId,
      (newVal) => {
        debugger;

        dataOptions.value.purchaseOption = [];
        PurchaseformData.purchase = ''

      }
    );

    let StoreId = Number(props.commonItemProps?.storeId) ?? 0;
    /*--*/

    /*Method calls*/
    //ListPurchaseOrder()
    /*--*/

    /*Method Declaration*/
    async function ListPurchaseOrder() {
      debugger;
      try {
        const result = await commonservice.GetListByDocNo(
          PurchaseformData.purchase,
          StoreId,
          "4,5,6"
        );
        dataOptions.value.purchaseOption = result["result"]

          .filter((item) => {
            if (item.DocType === "4" || item.DocType === "5") {
              return (
                item.Status !== 2 &&
                item.Status !== 4 &&
                item.Status !== 5 &&
                item.Status !== 6 &&
                item.IsApproved == 1 &&
                item.SupplierId == props.SupplierId
              );
            } else {
              return (
                item.Status !== 2 && item.Status !== 4 && item.Status !== 5
              );
            }
          })
          .map((item) => {
            item.label = item.DocNo;
            item.value = item.Id;
            return item;
          });
      } catch (error) { }
    }

    function update() {
      emit("update:modelValue", PurchaseformData);
    }
    const poItems = ref([]);
    async function poOnChange(data) {
      debugger;
      let poId = data.value.value;
      PurchaseformData.purchaseName = data.value.label;
      POItemLoad(poId);
    }
    async function POItemLoad(poId) {
      debugger;
      PurchaseformData.purchaseId = poId;

      const responsetable = await commonservice.GetByStockWOTransId(poId);
      poItems.value = responsetable["result"].map((i1) => {
        i1.RequestedQty = i1.ItemQuantity;
        i1.Rate = 0;
        return i1;
      });
      emit("getPoItems", poItems);
      update();
    }

    /*--*/
    return {
      dataOptions,
      PurchaseformData,
      poOnChange,
      update,
      ListPurchaseOrder,
    };
  },
});
</script>
